import React from 'react';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MultiLineInput from './MultiLineInput';

interface Props {
  question: FlowsQuestion;
}

const MultiLineInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { name, value, onBlur, onChange },
    error,
    prefilled,
  } = useFlowInputComponent({ question });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (e: any) => {
    const value = e.target.value;
    onChange({ name, value });
  };

  return (
    <MultiLineInput
      name={question.id}
      onChange={handleChange}
      prefilled={prefilled}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onBlur={(e: any) => onBlur(e)}
      value={value}
      error={error}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default MultiLineInputComponent;
